import React from 'react';

const renderUnit = (name, unit) => (
  <>
    <span style={{ marginBottom: 0 }}>{`${name} `}</span>
    <span style={{ color: 'gray' }}>{` ${unit}`}</span>
  </>
);
export default renderUnit;